import * as types from "../types/smsBalance"

const initialState = null

const smsBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SMS_BALANCE:
      return action.smsBalance
    case types.UPDATE_SMS_BALANCE:
      return action.smsBalance
    case types.CLEAR_SMS_BALANCE:
      return null
    default:
      return state
  }
}

export default smsBalanceReducer